export default __webpack_public_path__ + "static/OYOY-800x162-30fps-193ef4687959c105f9dd5bd299fa5ee9.mp4";